import { Injectable, inject } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs';
import { AppAlerts } from './app-alerts';

@Injectable({ providedIn: 'root' })
export class AppUpdatesService {
  private swUpdate = inject(SwUpdate);
  private alerts = inject(AppAlerts);

  init(): void {
    if (this.swUpdate.isEnabled) {
      this.handleUnrecoverableErrors();
      this.handleVersionUpdates();
    } else {
      console.log('Service worker is not enabled');
    }
  }

  private handleUnrecoverableErrors(): void {
    this.swUpdate.unrecoverable.subscribe(() => {
      this.alerts
        .confirmAlertTR({
          header: 'ERROR.UNRECOVERABLE',
          message: 'ERROR.UNRECOVERABLE_MESSAGE',
          yesCaption: 'COMMON.UPDATE',
          role: 'destructive',
        })
        .then((result) => {
          if (result) {
            this.reloadApp();
          }
        });
    });
  }

  private handleVersionUpdates(): void {
    this.swUpdate.versionUpdates
      .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
      .subscribe(() => {
        this.alerts
          .yesNoAlertTR({
            header: 'COMMON.UPDATE_AVAILABLE',
            message: 'COMMON.UPDATE_AVAILABLE_MESSAGE',
            yesCaption: 'COMMON.UPDATE',
            role: 'destructive',
          })
          .then((result) => {
            if (result) {
              this.reloadApp();
            }
          });
      });
  }

  private reloadApp(): void {
    document.location.reload();
  }

  async checkForUpdate(): Promise<boolean> {
    if (!this.swUpdate.isEnabled) {
      return false;
    }

    try {
      return await this.swUpdate.checkForUpdate();
    } catch (error) {
      console.error('Error checking for updates:', error);
      return false;
    }
  }

  async activateUpdate(): Promise<boolean> {
    if (!this.swUpdate.isEnabled) {
      return false;
    }

    try {
      return await this.swUpdate.activateUpdate();
    } catch (error) {
      console.error('Error activating update:', error);
      return false;
    }
  }
}
